// extracted by mini-css-extract-plugin
module.exports = {"arrow":"kf","dropMenu":"kg","dropMenuInner":"kh","itemborder":"ki","dropDownCurrent":"kj","menuItem":"kk","langContainer":"kl","current":"km","outlink":"kn"};